// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:25:31

export default {
  "id": "headless-joe-1",
  "slug": "headless-joe-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5597f518dcec46a394861c591353cabb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5597f518dcec46a394861c591353cabb/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Headless Joe",
      "description": "While playing, robot Joe literally lost his head. But it's not as hopeless as it seems. To get it back in place and screw it tightly, Joe needs to solve puzzles and collect all the bolts. But he can’t do this without your help!",
      "instructions": "Guide Joe through all the game levels, solving puzzles and avoiding danger. Press buttons, rotate levers, use elevators and platforms. Joe is a fragile guy. Don't let him fall!\nTry to get the maximum number of stars at all levels. You will have to try hard for this!\n\nControls:\nPC: use the mouse to control Joe, press buttons and interact with other game elements. 'P'/'Esc' - pause. 'R' - restart level.\n\nMobile: use touch control to control Joe, press buttons and interact with other game elements.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "cartoon",
        "physics",
        "platformer",
        "robot"
      ]
    },
    "zh-CN": {
      "title": "无头乔",
      "description": "在游戏中，机器人乔真的失去了头部。但情况并没有看起来那么绝望。为了将其放回原位并拧紧，乔需要解决谜题并收集所有螺栓。但如果没有你的帮助，他是无法做到的！",
      "instructions": "引导乔通过所有游戏关卡，解决谜题并避开危险。按按钮，旋转杠杆，使用电梯和平台。乔是个脆弱的家伙。别让他掉下去！\n\n尝试在所有关卡中获得尽可能多的星星。这将需要你努力！\n\n控制方式：\nPC：使用鼠标控制乔，按按钮并与游戏元素互动。'P'/'Esc' - 暂停。'R' - 重新开始关卡。\n\n移动设备：使用触摸控制来控制乔，按按钮并与游戏元素互动。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "卡通",
        "物理",
        "平台游戏",
        "机器人"
      ]
    },
    "zh-TW": {
      "title": "無頭約翰",
      "description": "當遊戲時，機器人喬實際上丟失了他的頭。但情況並沒有看起來那麼無望。為了將頭放回原位並緊緊旋緊螺絲，喬需要解謎並收集所有的螺栓。但沒有你的幫助，他無法完成這項任務！",
      "instructions": "引導Joe通過所有遊戲關卡，解決謎題並避開危險。按鈕、轉動桿桿、使用電梯和平臺。Joe是一個脆弱的家伙。不要讓他墜落！\n\n嘗試在所有關卡中獲得最多的星星。這需要你努力！\n\n控制方式：\nPC：使用滑鼠控制Joe，按鈕並與其他遊戲元素互動。'P'/'Esc' - 暫停。'R' - 重啟關卡。\n\n行動電話：使用觸控控制Joe，按鈕並與其他遊戲元素互動。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1 玩家",
        "卡通",
        "物理",
        "平台遊戲",
        "機器人"
      ]
    },
    "zh-HK": {
      "title": "無頭喬",
      "description": "玩遊戲時，機械人Joe真的是丟了他的頭。但情況並沒有看起來那麼絕望。要將頭安回原位並緊固螺絲，Joe需要解謎並收集所有螺帽。但沒有你幫助他做不到這些！",
      "instructions": "引導Joe通過所有遊戲關卡，解開謎題並避開危險。按鈕、轉動桿桿、使用電梯和平臺。Joe是一個脆弱的家伙。不要讓他墜落！\n\n盡量在所有關卡中獲得最多的星星。這會是一個艱難的挑戰！\n\n控制方式：\nPC：使用滑鼠控制Joe，按鈕並與其他遊戲元素互動。'P'/'Esc' - 暫停。'R' - 重啟關卡。\n\n手機：使用觸控控制Joe，按鈕並與其他遊戲元素互動。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "動畫風格",
        "物理遊戲",
        "平台遊戲",
        "機械人"
      ]
    },
    "ja": {
      "title": "ヘッドレス・ジョー",
      "description": "プレイ中に、ロボットのジョーは文字通りに頭を失った。しかし、見た目ほど絶望的ではありません。頭を元の場所に戻し、しっかりと締めるために、ジョーはパズルを解決し、すべてのボルトを収集する必要があります。しかし、あなたの助けなしにはそれができません！",
      "instructions": "ジョーをゲームの全レベルを通して導き、パズルを解き、危険を避けさせましょう。ボタンを押し、リバーを回転させ、エレベーターとプラットフォームを使用します。ジョーは脆弱な男です。彼が落ちないようにしましょう！\n\n全レベルで最大の星の数を目指しましょう。これは大変難しいことになります！\n\nコントロール：\nPC：マウスを使用してジョーを操作し、ボタンを押し、ゲームの他の要素と対話します。'P'/'Esc' - ペースト。'R' - レベルをリスタート。\n\nモバイル：タッチコントロールを使用してジョーを操作し、ボタンを押し、ゲームの他の要素と対話します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "アニメ",
        "物理",
        "パラード",
        "ロボット"
      ]
    },
    "ko": {
      "title": "헤드리스 조이",
      "description": "게임을 하면서 로봇 조이는 실제로 머리를 잃었습니다. 하지만 그렇게 희망빈해 보이진 않습니다. 머리를 원래 자리에 되돌리고 단단히 조이기 위해 조이는 퍼즐을 해결하고 모든 나사를 모으아야 합니다. 하지만 여기서는 여러분의 도움이 필요합니다!",
      "instructions": "지오를 모든 게임 레벨을 통해 안전하게 이끌어 주세요. 패ズ를 풀고 위험을 피하세요. 버튼을 누르고, 레버를 돌리며, 엘리베이터와 플랫폼을 사용하세요. 지오는 취약한 캐릭터입니다. 그를 떨어뜨리지 마세요!\n\n모든 레벨에서 가장 많은 별을 따우세요. 이를 위해 노력해야 합니다!\n\n컨트롤:\nPC: 마우스를 사용하여 지오를 제어하고, 버튼을 누르고 다른 게임 요소와 상호작용하세요. 'P'/'Esc' - 일시정지. 'R' - 레벨 재시작.\n\n모바일: 터치 컨트롤을 사용하여 지오를 제어하고, 버튼을 누르고 다른 게임 요소와 상호작용하세요.",
      "genres": [
        "캐주얼",
        "파uzzle"
      ],
      "tags": [
        "1플레이어,卡通",
        "물리학",
        "플랫폼 게임",
        "로봇"
      ]
    },
    "fr": {
      "title": "Joe sans tête",
      "description": "En jouant, le robot Joe a littéralement perdu la tête. Mais ce n'est pas aussi désespéré qu'il semble. Pour la remettre en place et la visser fermement, Joe doit résoudre des puzzles et collecter tous les vis. Mais il ne peut pas le faire sans ton aide !",
      "instructions": "Guidez Joe à travers tous les niveaux du jeu, résolvez des puzzles et évitez les dangers. Appuyez sur les boutons, faites pivoter les leviers, utilisez les ascenseurs et les plateformes. Joe est un homme fragile. Ne laissez pas tomber !\n\nEssayer d'obtenir le plus grand nombre de étoiles sur tous les niveaux. Vous devrez vous efforts pour cela !\n\nContrôles :\nPC : utilisez la souris pour contrôler Joe, appuyez sur les boutons et interagissez avec d'autres éléments du jeu. 'P'/'Esc' - mettre en pause. 'R' - redémarrer le niveau.\n\nMobile : utilisez le contrôle tactile pour contrôler Joe, appuyez sur les boutons et interagissez avec d'autres éléments du jeu.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "cartoon",
        "physique",
        "plate-forme",
        "robot"
      ]
    }
  }
};
